module.exports = __webpack_public_path__ + "static/Quote1-8439a9d3d004e0a1c4a8f6af7bcaf3c9.png";